module.exports = __webpack_public_path__ + "img/masks/02.svg";